import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AnalyticsTracker() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (loaded) return;
    fetch(`${API}/api/analytics/settings`)
      .then(r => r.json())
      .then(data => {
        // GA4
        if (data.ga4_id) {
          const s1 = document.createElement('script');
          s1.async = true;
          s1.src = `https://www.googletagmanager.com/gtag/js?id=${data.ga4_id}`;
          document.head.appendChild(s1);
          const s2 = document.createElement('script');
          s2.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${data.ga4_id}');`;
          document.head.appendChild(s2);
        }
        // Clarity
        if (data.clarity_id) {
          const s = document.createElement('script');
          s.textContent = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y)})(window,document,"clarity","script","${data.clarity_id}");`;
          document.head.appendChild(s);
        }
        setLoaded(true);
      })
      .catch(() => {});
  }, [loaded]);

  return null;
}
